import React from 'react';

interface TabIconProps {
  active: boolean;
}

const ActionPlanIcon: React.FC<TabIconProps> = ({ active }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9601_43943)">
      <path
        d="M7.06655 4.9987V7.4987H4.56655V4.9987H7.06655ZM2.89989 3.33203V9.16536H8.73324V3.33203H2.89989ZM11.2332 3.33203H17.8999V4.9987H11.2332V3.33203ZM11.2332 9.16536H17.8999V10.832H11.2332V9.16536ZM11.2332 14.9987H17.8999V16.6654H11.2332V14.9987ZM9.32249 13.5046L8.14396 12.3261L5.39989 15.0702L3.9058 13.5761L2.72729 14.7546L5.39989 17.4272L9.32249 13.5046Z"
        fill={active ? '#4E3178' : '#738290'}
      />
    </g>
    <defs>
      <clipPath id="clip0_9601_43943">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.399902)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ActionPlanIcon;
